import { render, staticRenderFns } from "./TheModalCategoria.vue?vue&type=template&id=3d7b5cc6&"
import script from "./TheModalCategoria.vue?vue&type=script&lang=js&"
export * from "./TheModalCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports